import {  ArcRotateCamera,  Vector3 } from "@babylonjs/core";
import { CameraSettings } from "./view";

export class ArcCamera
{
    private _upperAlphaLimit: number;
    private _lowerAlphaLimit: number;
    private _upperBetaLimit: number;
    private _lowerBetaLimit: number;
    private _upperRadiousLimit=20;
    private _lowerRadiousLimit=1;
    private _alpha: number;
    private _beta: number;
    private _radious: number;

    public camera: ArcRotateCamera;
    
    constructor(settings: CameraSettings, camera: ArcRotateCamera, canvas: HTMLCanvasElement)
    {
        this.camera = camera;
        if(settings.CameraUpperBetaLimit != null)
            this.UpperBetaLimit = settings.CameraUpperBetaLimit;
        if(settings.CameraLowerBetaLimit != null)
            this.LowerBetaLimit = settings.CameraLowerBetaLimit;
        if(settings.CameraUpperRadiousLimit != null)
            this.UpperRadiousLimit = settings.CameraUpperRadiousLimit;
        if(settings.CameralowerRadiousLimmit != null)
            this.LowerRadiousLimit = settings.CameralowerRadiousLimmit;
        if(settings.CameraLowerAlpha != null)
            this.LowerAlphaLimit = settings.CameraLowerAlpha;
        if(settings.CameraUpperAlpha != null)
            this.UpperAlphaLimit = settings.CameraUpperAlpha;
        if(settings.CameraAlpha != null)
            this.Alpha = settings.CameraAlpha;
        if(settings.CameraBeta != null)
            this.Beta = settings.CameraBeta;
        if(settings.CameraRadious != null)
            this.Radious = settings.CameraRadious;

        camera.attachControl(canvas, true);

        //camera.attachControl(view.Camera, true);
        //camera.attachControl();
        //camera.minZ = 0.1
    }
    public CenterModel(model:Vector3)
    {
        this.camera.setTarget(model, true, true, true);
    }

    get UpperBetaLimit():number {return this._upperBetaLimit;}
    set UpperBetaLimit(value:number)
    {
        this._upperBetaLimit = value;
        this.camera.upperBetaLimit = value;
    }
    get LowerBetaLimit():number {return this._lowerBetaLimit;}
    set LowerBetaLimit(value:number)
    {
        this._lowerBetaLimit=value;
        this.camera.lowerBetaLimit = value;
    }
    get UpperRadiousLimit():number {return this._upperRadiousLimit;}
    set UpperRadiousLimit(value:number)
    {
        this._upperRadiousLimit=value;
        this.camera.upperRadiusLimit = value;
    }
    get LowerRadiousLimit():number {return this._lowerRadiousLimit;}
    set LowerRadiousLimit(value:number)
    {
        this._lowerRadiousLimit= value;
        this.camera.lowerRadiusLimit = value;
    }
    get UpperAlphaLimit():number {return this._upperAlphaLimit;}
    set UpperAlphaLimit(value:number)
    {
        this._upperAlphaLimit=value;
        this.camera.upperAlphaLimit = value;
    }
    get LowerAlphaLimit():number {return this._lowerAlphaLimit;}
    set LowerAlphaLimit(value:number)
    {
        this._lowerAlphaLimit=value;
        this.camera.lowerAlphaLimit = value;
    }
    get Alpha():number {return this._alpha*180/Math.PI;}
    set Alpha(value:number)
    {
        this._alpha=(value*Math.PI)/180;
        this.camera.alpha = (value*Math.PI)/180;
    }
    get Beta():number {return this._beta*180/Math.PI;}
    set Beta(value:number)
    {
        this._beta=(value*Math.PI)/180;
        this.camera.beta = (value*Math.PI)/180;
    }
    get Radious():number {return this._radious;}
    set Radious(value:number)
    {
        this._radious=value;
        this.camera.radius = value;
    }
    get AutoRotate():number {return this._radious;}
    set AutoRotate(value:number)
    {
        this._radious=value;
        this.camera.radius = value;
    }
   
}